import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 68.252 45.501',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2" transform="translate(0 -64)">
        <path
          fill={fill}
          d="M68.252,81.063V69.688A5.688,5.688,0,0,0,62.564,64H5.688A5.688,5.688,0,0,0,0,69.688V81.063a5.688,5.688,0,0,1,5.688,5.688A5.688,5.688,0,0,1,0,92.438v11.375A5.688,5.688,0,0,0,5.688,109.5H62.564a5.688,5.688,0,0,0,5.688-5.688V92.438a5.688,5.688,0,1,1,0-11.375ZM47.4,103.814a1.9,1.9,0,1,1,1.9-1.9A1.9,1.9,0,0,1,47.4,103.814Zm0-7.584a1.9,1.9,0,1,1,1.9-1.9A1.9,1.9,0,0,1,47.4,96.23Zm0-7.584a1.9,1.9,0,1,1,1.9-1.9A1.9,1.9,0,0,1,47.4,88.647Zm0-7.584a1.9,1.9,0,1,1,1.9-1.9A1.9,1.9,0,0,1,47.4,81.063Zm0-7.584a1.9,1.9,0,1,1,1.9-1.9A1.9,1.9,0,0,1,47.4,73.479Z"
          transform="translate(0 0)"
          opacity="0.5"
        />
        <path
          fill={fill}
          d="M385.9,134.751a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,385.9,134.751Zm0,7.584a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,385.9,142.334Zm0-26.542a1.9,1.9,0,1,0-1.9-1.9A1.9,1.9,0,0,0,385.9,115.792Zm0,11.375a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,385.9,127.167Zm0-7.584a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,385.9,119.584Z"
          transform="translate(-338.499 -42.312)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
